import React from "react";
import { Link } from "react-router-dom";

const SecondaryFooter = () => {
  const year = new Date().getFullYear();

  return (
    <div className="d-flex flex-md-row flex-column-reverse py-5 justify-content-between align-items-center gap-md-5 gap-2">
      <div className="text-muted small">
        Copyright © {year} MedHive. All rights reserved.
      </div>

      <ul className="list-inline small fw-semibold mb-0 d-flex flex-row align-items-center justify-content-end gap-3">
        <li className="list-inline-item">
          <Link to="/privacy" className="text-decoration-none p-0">
            Privacy Policy
          </Link>
        </li>
        <li className="list-inline-item">
          <Link to="/terms" className="text-decoration-none p-0">
            Terms of Service
          </Link>
        </li>
        <li className="list-inline-item">
          <Link to="/cookies" className="text-decoration-none p-0">
            Cookies
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SecondaryFooter;
